(function () {
  if (window.__fastplusGlobalSearchReady) return;
  window.__fastplusGlobalSearchReady = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var state = { dialog: null, input: null, results: null, trigger: null, timer: null, request: null };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function endpoint(path) {
    return root.replace(/\/$/, '') + path;
  }

  function ensureDialog() {
    if (state.dialog) return state.dialog;
    var shell = document.createElement('div');
    shell.className = 'fp-site-search';
    shell.id = 'fastplus-search-dialog';
    shell.setAttribute('role', 'dialog');
    shell.setAttribute('aria-modal', 'true');
    shell.setAttribute('aria-labelledby', 'fastplus-search-title');
    shell.setAttribute('aria-hidden', 'true');
    shell.innerHTML = [
      '<button class="fp-site-search__backdrop" type="button" data-search-close tabindex="-1" aria-label="Close search"></button>',
      '<div class="fp-site-search__dialog">',
        '<div class="fp-site-search__head">',
          '<h2 class="fp-site-search__title" id="fastplus-search-title">Search FastPlus</h2>',
          '<button class="fp-site-search__close" type="button" data-search-close aria-label="Close search">&times;</button>',
        '</div>',
        '<form class="fp-site-search__form" action="' + escapeHtml(endpoint('/search')) + '" method="get" role="search">',
          '<input type="hidden" name="type" value="product,page,article">',
          '<input type="hidden" name="options[prefix]" value="last">',
          '<label class="sr-only" for="fastplus-search-input">Search products, pages, and articles</label>',
          '<input class="fp-site-search__input" id="fastplus-search-input" type="search" name="q" placeholder="Search products, pages, and guides" autocomplete="off" enterkeyhint="search">',
          '<button class="fp-site-search__submit" type="submit">Search</button>',
        '</form>',
        '<div class="fp-site-search__results" id="fastplus-search-results" aria-live="polite" hidden></div>',
      '</div>'
    ].join('');
    document.body.appendChild(shell);
    state.dialog = shell;
    state.input = shell.querySelector('#fastplus-search-input');
    state.results = shell.querySelector('#fastplus-search-results');
    if (window.matchMedia('(max-width: 600px)').matches) state.input.placeholder = 'Search FastPlus';

    shell.addEventListener('click', function (event) {
      if (event.target.closest('[data-search-close]')) closeSearch();
    });
    state.input.addEventListener('input', queueSuggestions);
    return shell;
  }

  function openSearch(trigger) {
    var shell = ensureDialog();
    state.trigger = trigger || document.getElementById('search-toggle');
    shell.classList.add('is-open');
    shell.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fp-site-search-open');
    if (state.trigger) state.trigger.setAttribute('aria-expanded', 'true');
    state.input.focus({ preventScroll: true });
    window.requestAnimationFrame(function () { state.input.focus({ preventScroll: true }); });
    window.setTimeout(function () {
      if (state.dialog && state.dialog.classList.contains('is-open')) state.input.focus({ preventScroll: true });
    }, 80);
  }

  function closeSearch() {
    if (!state.dialog) return;
    state.dialog.classList.remove('is-open');
    state.dialog.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fp-site-search-open');
    if (state.trigger) {
      state.trigger.setAttribute('aria-expanded', 'false');
      state.trigger.focus();
    }
  }

  function resultImage(item, type) {
    var image = item.featured_image && (item.featured_image.url || item.featured_image);
    if (!image && item.image) image = item.image.url || item.image;
    if (image) {
      image += (String(image).indexOf('?') === -1 ? '?' : '&') + 'width=96';
      return '<img class="fp-site-search__thumb" src="' + escapeHtml(image) + '" alt="" width="48" height="48" loading="lazy">';
    }
    return '<span class="fp-site-search__placeholder" aria-hidden="true">' + escapeHtml(type.slice(0, 1)) + '</span>';
  }

  function resultGroup(title, type, items) {
    if (!items || !items.length) return '';
    return '<div class="fp-site-search__group">' +
      '<h3 class="fp-site-search__group-title">' + escapeHtml(title) + '</h3>' +
      items.map(function (item) {
        return '<a class="fp-site-search__item" href="' + escapeHtml(item.url) + '">' +
          resultImage(item, type) +
          '<span class="fp-site-search__item-title">' + escapeHtml(item.title) + '</span>' +
          '<span class="fp-site-search__item-type">' + escapeHtml(type) + '</span>' +
        '</a>';
      }).join('') +
    '</div>';
  }

  function renderSuggestions(query, data) {
    var resources = data && data.resources && data.resources.results ? data.resources.results : {};
    var markup = resultGroup('Products', 'Product', resources.products) +
      resultGroup('Pages', 'Page', resources.pages) +
      resultGroup('Articles', 'Article', resources.articles);
    state.results.hidden = false;
    if (!markup) {
      state.results.innerHTML = '<p class="fp-site-search__status">No results found.</p>';
      return;
    }
    state.results.innerHTML = markup +
      '<a class="fp-site-search__all" href="' + escapeHtml(endpoint('/search?q=' + encodeURIComponent(query) + '&type=product%2Cpage%2Carticle&options%5Bprefix%5D=last')) + '">View all results</a>';
  }

  function loadSuggestions(query) {
    if (state.request) state.request.abort();
    state.request = new AbortController();
    state.results.hidden = false;
    state.results.innerHTML = '<p class="fp-site-search__status">Searching...</p>';
    var url = endpoint('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page,article&resources[limit]=5&resources[options][unavailable_products]=last');
    fetch(url, { headers: { Accept: 'application/json' }, signal: state.request.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.json();
      })
      .then(function (data) { renderSuggestions(query, data); })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        state.results.innerHTML = '<p class="fp-site-search__status">Press Enter to see search results.</p>';
      });
  }

  function queueSuggestions() {
    window.clearTimeout(state.timer);
    var query = state.input.value.trim();
    if (query.length < 2) {
      if (state.request) state.request.abort();
      state.results.hidden = true;
      state.results.innerHTML = '';
      return;
    }
    state.timer = window.setTimeout(function () { loadSuggestions(query); }, 180);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('#search-toggle');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    openSearch(trigger);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && state.dialog && state.dialog.classList.contains('is-open')) closeSearch();
  });

  window.FastplusGlobalSearch = { open: openSearch, close: closeSearch };
})();
